import { STRUCTURING_API } from './structuringUtils';

export type Operation = {
    id: string;
    operationCode: string;
    assignorName: string;
    assignorCnpj: string;
    status: string;
    totalDocuments: number;
    totalReceivables: number;
    totalAmount: number;
    processingDate: string;
    updatedDate: string;
    notes: string;
    canEdit: boolean;
    canRemove: boolean;
    canViewDetail: boolean;
    canDownload: boolean;
};

export const buildFetchUrl = (page: string, pageSize: string): string => {
    return `${STRUCTURING_API.url}/operations?page=${page}&pageSize=${pageSize}`;
};

export const buildFetchHeaders = () => [
    { key: 'x-api-key', value: STRUCTURING_API.key || '' },
    { key: 'Accept-Charset', value: 'utf-8' }
];

export const buildTableHeaders = () => [
    { id: 'operationCode', title: 'Código', canSort: false, field: 'operationCode' },
    { id: 'assignorName', title: 'Cedente', canSort: false, field: 'assignorName' },
    { id: 'totalDocuments', title: 'Documentos', canSort: false, field: 'totalDocuments' },
    { id: 'totalReceivables', title: 'Recebíveis', canSort: false, field: 'totalReceivables' },
    { id: 'totalAmount', title: 'Valor Total', canSort: false, field: 'totalAmount' },
    { id: 'processingDate', title: 'Processamento', canSort: false, field: 'processingDate' },
    { id: 'status', title: 'Status', canSort: false, field: 'status' },
    { id: 'actions', title: 'Ações', canSort: false }
];

export const deleteOperation = async (operationId: string): Promise<{ success: boolean; message: string }> => {
    try {
        const response = await fetch(`${STRUCTURING_API.url}/operations/${operationId}`, {
            method: 'DELETE',
            headers: {
                'x-api-key': STRUCTURING_API.key || '',
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        if (response.ok) {
            return { success: true, message: data.message || 'Operação deletada com sucesso' };
        } else {
            return { success: false, message: data.message || 'Erro ao deletar operação' };
        }
    } catch (error) {
        console.error('Erro ao deletar operação:', error);
        return { success: false, message: 'Erro de conexão ao deletar operação' };
    }
};
